module.exports = __webpack_public_path__ + "img/mic_main2.696fc950.svg";